// extracted by mini-css-extract-plugin
export default {"table_box":"dislyteTable_table_box__X2bJz","table_title":"dislyteTable_table_title__V1850","m":"dislyteTable_m__6cT9y"};